import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ResponseSplitOrder } from 'src/app/models/responseSplitOrder';
import { GeneralTool } from '../tools/general-tools';
import { ORDER_STATES } from 'src/app/core/constants/General-constants';

@Component({
  selector: 'app-info-order-link',
  templateUrl: './info-order-link.component.html',
  styleUrls: ['./info-order-link.component.scss']
})
export class InfoOrderLinkComponent implements OnInit, AfterViewInit {
  @ViewChildren('childDiv') childDivs: QueryList<ElementRef>;
  @Input() paymentList: ResponseSplitOrder['DATA'];
  @Input() currency: string;

  importantMessage = 'split-Important-Info';
  orderedPaymentList: ResponseSplitOrder['DATA'];

  constructor() { }

  ngOnInit(): void {
    this.orderedPaymentList = this.paymentList.sort((a, b) => a.orderConsecutive - b.orderConsecutive);
    this.buildCustomMsg();
  }
  /**
   * 
   * {redirectCheckout} Function to redirect checkout split payment links
   * @param orderLink 
  */
  redirectCheckout(orderLink: string) {
    if (!GeneralTool.validateUrlProtocol(orderLink)) {
      orderLink = `https://${orderLink}`;
    }
    window.location.href = orderLink;
  }
  /**
   * {buildCustomMsg} Function to build the informative message of the component
  */
  buildCustomMsg = (): void => {
    const [value1, value2] = this.orderedPaymentList;

    this.importantMessage =
      value1.status === ORDER_STATES.APPROVED && value2.status === ORDER_STATES.PENDING
        ? 'split-Important-Info-Pay-two'
        : value1.status === ORDER_STATES.APPROVED ? '' : 'split-Important-Info';
  }
  /**
   * 
   * @description {isPending} Function to validate if an order is pending
   * @returns 
  */
  isPending = () => {
    return this.orderedPaymentList.find((e) => e.status === ORDER_STATES.PENDING);
  }
  /**
   * @description {ngAfterViewInit} Function to assign styles to component after it has been initialized 
  */
  ngAfterViewInit() {
    if (this.isPending()) {
      this.childDivs.forEach((div: ElementRef) => {
        if (div.nativeElement.querySelector('app-copy-to-clipboard')) {
          const clipBoard = div.nativeElement.querySelector('app-copy-to-clipboard');
          clipBoard.querySelector('p').style.fontSize = '15px';
        }
      });
    }
  }
}
